import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface SeoData {
  title: string | null;
  description: string | null;
  og_title: string | null;
  og_description: string | null;
  og_image: string | null;
  canonical_url: string | null;
  keywords: string[] | null;
  schema_type: string | null;
}

const cache = new Map<string, SeoData | null>();

export function useSeoSettings(pagePath: string): SeoData | null {
  const [data, setData] = useState<SeoData | null>(cache.get(pagePath) || null);

  useEffect(() => {
    if (cache.has(pagePath)) {
      setData(cache.get(pagePath) || null);
      return;
    }

    supabase
      .from("seo_settings")
      .select("title, description, og_title, og_description, og_image, canonical_url, keywords, schema_type")
      .eq("page_path", pagePath)
      .maybeSingle()
      .then(({ data: row }) => {
        const result = row as SeoData | null;
        cache.set(pagePath, result);
        setData(result);
      });
  }, [pagePath]);

  return data;
}
